global.$ = require('jquery')
global.jQuery = $;
global.moment = require('moment-mini');
require('js-cookie');
require('tablednd');
global.signalR = require("@microsoft/signalr");
global.d3 = {
	...require('d3-shape'),
	...require('d3-selection'),
	...require('d3-scale'),
	...require('d3-scale-chromatic'),
	...require('d3-array'),
	...require('d3-axis'),
	...require('d3-format')
};
global.reactivity = {
	...require('@vue/reactivity')
};

global.Tango = {
	...require('Tango/tango/tango.errormsg.js'),
	...require('Tango/tango/tango.serializeForm.js'),
	...require('Tango/tango/tango.formatters.js')
};

require('Tango/tango/commonutils.js');
require('Tango/tango/observablearray.js');
require('Tango/tango/reactivetracker.js');
require('Tango/tango/domactions.js');
require('Tango/tango/tango.js');
require('Tango/tango/tango.component.js');
require('Tango/tango/contextmenuproxy.js');
require('Tango/tango/listview.js');
require('Tango/calendar/calendar_stripped.js');
require('Tango/calendar/calendarcontrol.js');
require('Tango/daterangepicker/daterangepicker.js');
require('Tango/tango/daterangepickerproxy.js');
require('Tango/tango/tabs.js');
require('Tango/contextmenu/contextmenu.js');
require('Tango/tango/dialog.js');
require('Tango/tango/selectdialog.js');
require('Tango/jquery/jquery.btnswitch.js');
require('Tango/tango/tangohub.js');